var app = angular.module("leonardo");

var VendorForm = function($scope, $state, $q, vendorObj, ngDialog, VendorService, AccountUserService, NotificationService,
                          LevelService, CategoryVendorService, FormErrorsService, AccountService, AuthDataService) {
  $scope.action = $state.current.action;
  $scope.categoryVendorService = CategoryVendorService;

  if (vendorObj){
    $scope.data = vendorObj;
    $scope.data.category = vendorObj.category.id;
    $scope.data.address = {
      address: vendorObj.address,
      lat: vendorObj.latitude,
      long: vendorObj.longitude
    };
    if (AccountUserService.currentAccountUser) {
      $scope.data.account_user_membership = AccountUserService.currentAccountUser.id;
    }
    if (vendorObj.account_membership) {
      $scope.data.account_membership = vendorObj.account_membership.id;
    }
    delete ($scope.data.creator);

    angular.forEach($scope.data.levels, function(value){
      switch (value.level_type) {
        case LevelService.TYPE_STATE:
          $scope.data.state = value.id;
          LevelService.getlist({level_type: LevelService.TYPE_COUNTY, parents: $scope.data.state, disable_pagination: true}, true).then(function(counties){
            $scope.counties = counties;
          });
          break;
        case LevelService.TYPE_COUNTY:
          $scope.data.county = value.id;
          LevelService.getlist({level_type: LevelService.TYPE_CITY, parents: $scope.data.county, disable_pagination: true}, true).then(function(cities){
            $scope.cities = cities;
          });
          break;
        case LevelService.TYPE_CITY:
          $scope.data.city = value.id;
          LevelService.getlist({level_type: LevelService.TYPE_ZIPCODE, parents: $scope.data.city, disable_pagination: true}, true).then(function(zipcodes){
            $scope.zipcodes = zipcodes;
          });
          break;
        case LevelService.TYPE_ZIPCODE:
          $scope.data.zipcode = value.id;
          break;
      }
    });
  }
  else {
    $scope.data = {
      account_user: {user: {email: '', first_name: '', last_name: ''}},
      address: {address:'', long: null, lat: null},
      working_radius: 100
    };
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_vendor'
        }
      }).then(function (account) {
        if (!account){
          window.history.back();
        }
        $scope.data.account_membership = (account !== 'all') ? account : null;
      }, function() {
        window.history.back();
      });
    }
    else {
      $scope.data.account_membership = AccountUserService.currentAccountUser.account;
    }
  }

  LevelService.getlist({level_type: LevelService.TYPE_STATE, disable_pagination: true}).then(function(data){
    $scope.states = data;
  });
  $scope.counties = [];
  $scope.cities = [];

  $scope.onStateChange = function() {
    var defer = $q.defer();
    if (!$scope.data.state){
      $scope.data.county = null;
      $scope.counties = [];
      defer.resolve();
    }
    else {
      LevelService.getlist({level_type: LevelService.TYPE_COUNTY, parents: $scope.data.state, disable_pagination: true}).then(function(counties){
        $scope.counties = counties;
        $scope.data.county = null;
        defer.resolve();
      });
    }
    return defer.promise;
  };

  $scope.onCountyChange = function() {
    var defer = $q.defer();
    if (!$scope.data.county){
      $scope.data.city = null;
      $scope.cities = [];
      defer.resolve();
    }
    else {
      LevelService.getlist({level_type: LevelService.TYPE_CITY, parents: $scope.data.county, disable_pagination: true}).then(function(cities){
        $scope.cities = cities;
        $scope.data.city = null;
        defer.resolve();
      });
    }
    return defer.promise;
  };

  $scope.onCityChange = function() {
    var defer = $q.defer();
    $scope.data.zipcode = null;
    if (!$scope.data.city){
      $scope.zipcodes = [];
      defer.resolve();
    }
    else {
      LevelService.getlist({level_type: LevelService.TYPE_ZIPCODE, parents: $scope.data.city, disable_pagination: true}).then(function(zipcodes){
        $scope.zipcodes = zipcodes;
        defer.resolve();
      });
    }
    return defer.promise;
  };

  $scope.states = [
    { name: 'ALABAMA', abbreviation: 'AL'},
    { name: 'ALASKA', abbreviation: 'AK'},
    { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
    { name: 'ARIZONA', abbreviation: 'AZ'},
    { name: 'ARKANSAS', abbreviation: 'AR'},
    { name: 'CALIFORNIA', abbreviation: 'CA'},
    { name: 'COLORADO', abbreviation: 'CO'},
    { name: 'CONNECTICUT', abbreviation: 'CT'},
    { name: 'DELAWARE', abbreviation: 'DE'},
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
    { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
    { name: 'FLORIDA', abbreviation: 'FL'},
    { name: 'GEORGIA', abbreviation: 'GA'},
    { name: 'GUAM', abbreviation: 'GU'},
    { name: 'HAWAII', abbreviation: 'HI'},
    { name: 'IDAHO', abbreviation: 'ID'},
    { name: 'ILLINOIS', abbreviation: 'IL'},
    { name: 'INDIANA', abbreviation: 'IN'},
    { name: 'IOWA', abbreviation: 'IA'},
    { name: 'KANSAS', abbreviation: 'KS'},
    { name: 'KENTUCKY', abbreviation: 'KY'},
    { name: 'LOUISIANA', abbreviation: 'LA'},
    { name: 'MAINE', abbreviation: 'ME'},
    { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
    { name: 'MARYLAND', abbreviation: 'MD'},
    { name: 'MASSACHUSETTS', abbreviation: 'MA'},
    { name: 'MICHIGAN', abbreviation: 'MI'},
    { name: 'MINNESOTA', abbreviation: 'MN'},
    { name: 'MISSISSIPPI', abbreviation: 'MS'},
    { name: 'MISSOURI', abbreviation: 'MO'},
    { name: 'MONTANA', abbreviation: 'MT'},
    { name: 'NEBRASKA', abbreviation: 'NE'},
    { name: 'NEVADA', abbreviation: 'NV'},
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
    { name: 'NEW JERSEY', abbreviation: 'NJ'},
    { name: 'NEW MEXICO', abbreviation: 'NM'},
    { name: 'NEW YORK', abbreviation: 'NY'},
    { name: 'NORTH CAROLINA', abbreviation: 'NC'},
    { name: 'NORTH DAKOTA', abbreviation: 'ND'},
    { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
    { name: 'OHIO', abbreviation: 'OH'},
    { name: 'OKLAHOMA', abbreviation: 'OK'},
    { name: 'OREGON', abbreviation: 'OR'},
    { name: 'PALAU', abbreviation: 'PW'},
    { name: 'PENNSYLVANIA', abbreviation: 'PA'},
    { name: 'PUERTO RICO', abbreviation: 'PR'},
    { name: 'RHODE ISLAND', abbreviation: 'RI'},
    { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
    { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
    { name: 'TENNESSEE', abbreviation: 'TN'},
    { name: 'TEXAS', abbreviation: 'TX'},
    { name: 'UTAH', abbreviation: 'UT'},
    { name: 'VERMONT', abbreviation: 'VT'},
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
    { name: 'VIRGINIA', abbreviation: 'VA'},
    { name: 'WASHINGTON', abbreviation: 'WA'},
    { name: 'WEST VIRGINIA', abbreviation: 'WV'},
    { name: 'WISCONSIN', abbreviation: 'WI'},
    { name: 'WYOMING', abbreviation: 'WY' }
];

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    data.latitude = data.address.lat;
    data.longitude = data.address.long;
    data.address = data.address.address;
    data.levels = [];
    if(data.state) {
      data.levels.push(data.state);
    }
    if(data.county) {
      data.levels.push(data.county);
    }
    if(data.city) {
      data.levels.push(data.city);
    }
    if(data.zipcode) {
      data.levels.push(data.zipcode);
    }

    if ($scope.action === 'edit'){
      $scope.data.patch(data).then(function(){
        $state.go('vendors.overview');
      }, function(error){
        if (angular.isArray(error.data)) {
          angular.forEach(error.data, function(value, key){
            if (key === 'email') {
              NotificationService.error('Email address must be unique. Please try again.');
            }
            else if (key === 'latitude' || key === 'longitude') {
              NotificationService.error("Please enter vendor's complete address.");
            }
            else {
              NotificationService.error(key + ', ' + value[0]);
            }
          });
        }
        else {
          NotificationService.error('An unexpected error has occurred.');
        }
      });
    }
    else {
      VendorService.post(data).then(function(result) {
        VendorService.updateCollection(result);
        $state.go('vendors.overview');
      }, function(error){
        if (angular.isArray(error.data)) {
          angular.forEach(error.data, function(value, key){
            if (key === 'email') {
              NotificationService.error('Email address must be unique. Please try again.');
            }
            else if (key === 'latitude' || key === 'longitude') {
              NotificationService.error("Please enter vendor's complete address.");
            }
            else {
              NotificationService.error(key + ', ' + value[0]);
            }
          });
        }
        else {
          NotificationService.error('An unexpected error has occurred.');
        }
      });
    }
  };

};

app.controller('VendorForm', ['$scope', '$state', '$q', 'vendorObj', 'ngDialog', 'VendorService', 'AccountUserService',
  'NotificationService', 'LevelService', 'CategoryVendorService', 'FormErrorsService', 'AccountService', 'AuthDataService', VendorForm]);
